import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';

import { $$api } from '@doger/core/shared/api';

import { useAuthContext } from './auth.context';

const useSignOut = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const { signOutUrl } = useAuthContext();

  return useMutation({
    mutationFn: async () => {
      void $$api.logout();
    },

    onSuccess: () => {
      navigate(signOutUrl);
      $$api.tokensService.removeTokens();
      setTimeout(() => {
        queryClient.resetQueries({ queryKey: ['auth'] });
      });
    },
  });
};

export { useSignOut };
